import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from './components/Login.vue'
import Logout from './components/Logout.vue'
import Home from './components/Home.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        { path: '/', component: Home },
        { path: '/login', component: Login },
        { path: '/logout', component: Logout }
    ]
})

export default router;